import _regeneratorRuntime from "@babel/runtime/regenerator";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getContentBlockerNodes, transformToOriginalContentBlockerAttribute, putScriptInlineToDom, createContentBlocker } from ".";
import { unmountComponentAtNode } from "react-dom";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { applyDOMContentLoadedInitiator, applyJQueryInitiator, applyWindowLoadInitiator } from "..";
import { probablyResetParentContainerForContentBlocker, putStyleInlineToDom } from ".";
import { BLOCKER_LAST_CLICKED_CONNECTED_COUNTER } from "../../components"; // Also ported to `view/Blocker.php`

export var HTML_ATTRIBUTE_CAPTURE_PREFIX = "consent-original";
export var HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX = "consent-click-original";
export var HTML_ATTRIBUTE_CAPTURE_SUFFIX = "_";
export var HTML_ATTRIBUTE_COOKIE_IDS = "consent-required";
export var HTML_ATTRIBUTE_VISUAL_PARENT = "consent-visual-use-parent";
export var HTML_ATTRIBUTE_INLINE = "consent-inline";
export var HTML_ATTRIBUTE_INLINE_STYLE = "consent-inline-style";
export var HTML_ATTRIBUTE_BLOCKER_ID = "consent-id";
export var HTML_TAG_CONSENT_SCRIPT = "span";
export var HTML_ATTRIBUTE_BLOCKER_CONNECTED = "consent-blocker-connected";
/**
 * Refresh the DOM content depending on accepted cookies. It covers the following things:
 *
 * - Get all available blocked content
 * - Unblock blocked content depending on the passed accepted cookies
 * - All other blocked content gets a visual content-blocker (if possible)
 */

function manipulateContentBlockerDOM(_x) {
  return _manipulateContentBlockerDOM.apply(this, arguments);
}

function _manipulateContentBlockerDOM() {
  _manipulateContentBlockerDOM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookies) {
    var nodes, _iterator, _step, row, consent, node, blocker, connectedBlocker, isLastClicked, contentBlockers, _iterator2, _step2, contentBlocker, ownerDocument;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            nodes = getContentBlockerNodes(cookies);
            _iterator = _createForOfIteratorHelper(nodes);
            _context.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context.next = 36;
              break;
            }

            row = _step.value;
            consent = row.consent, node = row.node, blocker = row.blocker;

            if (!consent) {
              _context.next = 33;
              break;
            }

            // Immediate deactivate nodes for future unblocks
            node.removeAttribute(HTML_ATTRIBUTE_COOKIE_IDS); // Remove visual content blocker if given

            connectedBlocker = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);
            isLastClicked = "".concat(BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count) === connectedBlocker;

            if (isLastClicked) {
              BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count = undefined; // Reset to avoid double auto plays
            }

            if (connectedBlocker) {
              contentBlockers = Array.prototype.slice.call(document.querySelectorAll(".rcb-content-blocker[consent-blocker-connected=\"".concat(connectedBlocker, "\"]")));
              _iterator2 = _createForOfIteratorHelper(contentBlockers);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  contentBlocker = _step2.value;
                  unmountComponentAtNode(contentBlocker);
                  probablyResetParentContainerForContentBlocker(contentBlocker, false);
                  contentBlocker.remove();
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } // Overwrite global listeners so they get immediate executed


            ownerDocument = node.ownerDocument;
            applyDOMContentLoadedInitiator(ownerDocument);
            applyJQueryInitiator(ownerDocument);
            applyWindowLoadInitiator(ownerDocument); // Activate node

            if (!node.hasAttribute(HTML_ATTRIBUTE_INLINE)) {
              _context.next = 22;
              break;
            }

            _context.next = 20;
            return putScriptInlineToDom(node);

          case 20:
            _context.next = 29;
            break;

          case 22:
            if (!node.hasAttribute(HTML_ATTRIBUTE_INLINE_STYLE)) {
              _context.next = 27;
              break;
            }

            _context.next = 25;
            return putStyleInlineToDom(node);

          case 25:
            _context.next = 29;
            break;

          case 27:
            _context.next = 29;
            return transformToOriginalContentBlockerAttribute(node, isLastClicked);

          case 29:
            node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                gotClicked: isLastClicked
              }
            }));
            document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                element: node,
                gotClicked: isLastClicked
              }
            }));
            _context.next = 34;
            break;

          case 33:
            createContentBlocker(row);

          case 34:
            _context.next = 4;
            break;

          case 36:
            _context.next = 41;
            break;

          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](2);

            _iterator.e(_context.t0);

          case 41:
            _context.prev = 41;

            _iterator.f();

            return _context.finish(41);

          case 44:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 38, 41, 44]]);
  }));
  return _manipulateContentBlockerDOM.apply(this, arguments);
}

export { manipulateContentBlockerDOM };